import styled from 'styled-components';
import {
  cardCouponSectionItemStyles,
  subscriptionModalSectionWrapperStyles,
  subscriptionModalSidePaddings
} from '@anm/styles/helpers';
import Button from '@anm/components/buttons/Button/Button';

export const SecurePurchaseBlockWrapper = styled.div`
  ${subscriptionModalSectionWrapperStyles};
  ${subscriptionModalSidePaddings};
  background-color: var(--blue_100);
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 0 0 5px 5px;
`;

export const SecurePurchaseBlockItem = styled.div`
  ${cardCouponSectionItemStyles};
  min-height: auto;
  ${Button} {
    width: 100%;
  }
`;
